import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  p: (p) => p.spacing(1),
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(1),
};

export const potentialyLostCredits: SxStyle = {
  borderColor: (p) => p.palette.error[300],
  background: (p) => p.palette.error[50],
  '.credit-value': {
    color: (p) => p.palette.error[600],
  },
};

export const currentBalance: SxStyle = {
  '.credit-value': {
    color: (p) => p.palette.success[600],
    fontWeight: (p) => p.typography.fontWeightSemiBold,
  },
};
